export default {
  breakpointSM: 576,
  breakpointMD: 768,
}